export default __webpack_public_path__ + "static/media/vk.6ba9d164.png";